import { useAtomValue } from "jotai";
import { tokenAtom } from "@/atoms/authAtoms";
import { authService } from "@/services/auth";
import { decodeToken } from "@/utils/tokenUtils";

/** Lower-cased email of the signed-in caller, matched against `recorded_by` fields. */
export function useCallerEmail() {
  const atomToken = useAtomValue(tokenAtom);
  // Use the request interceptor's cookie token before the auth atom snapshot.
  const token = authService.getStoredAuth().token ?? atomToken;
  return token ? decodeToken(token)?.email?.toLowerCase() : undefined;
}
